import { alpha } from "@mui/material";

const styles = (theme) => ({
	botaoTracejado: {
		textTransform: "none",
		borderStyle: "dashed",
		borderWidth: 1,
		borderColor: theme.palette.divider,
		color: theme.palette.primary.main,
		justifyContent: "center",
		py: 1,
		"&:hover": {
			borderStyle: "dashed",
			borderColor: theme.palette.primary.main,
			bgcolor: alpha(theme.palette.primary.main, 0.06),
		},
	},
	chaveMono: {
		fontFamily: "monospace",
		fontSize: "0.7rem",
		color: theme.palette.text.disabled,
	},
	chaveMonoDestaque: {
		fontFamily: "monospace",
		fontSize: "0.9rem",
		fontWeight: 600,
		color: theme.palette.primary.main,
	},
	inputMono: {
		fontFamily: "monospace",
		fontSize: "0.85rem",
	},
	editPaper: {
		p: 2,
		width: 340,
		display: "flex",
		flexDirection: "column",
		gap: 1.5,
	},
	alertaInfo: {
		fontSize: "0.75rem",
	},
	listaModelos: {
		pl: 2,
		my: 0.5,
		"& li": { fontSize: "0.7rem", lineHeight: 1.5 },
	},
});

export default styles;
